<h3 mat-dialog-title >
    <b>Patrimônio</b> 
</h3>
<div fxLayout="column" fxLayoutAlign="center center" style="margin-bottom: 16px;">
    <mat-label style="font-size: 1.1em;">Patrimônio Financeiro</mat-label>
    <!-- todo: appearance="outline" -->
    <mat-button-toggle-group
    aria-label="Defina se o patrimônio é financeiro"
    style="display: inline-flex;"
    [formControl]="is_financeiro"
    >
        <mat-button-toggle [value]="true" style="font-size: 1.1em;">Sim</mat-button-toggle>
        <mat-button-toggle [value]="false" style="font-size: 1.1em;">Não</mat-button-toggle>
    </mat-button-toggle-group>
</div>

<!-- Campos comum nos patrimonios financeiros ou não -->
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" style="width: 100%" fxFlex="100">
       <mat-label>Tipo de Patrimônio</mat-label>
       <mat-select
            [formControl]="tipo_patrimonio_id">
            <mat-option value="">SELECIONE</mat-option>
            <mat-option *ngFor="let tipoPatrimonio of listaTipoPatrimonioFiltrada()" 
            [value]="tipoPatrimonio.id">
                {{ tipoPatrimonio.descricao }}
            </mat-option>
       </mat-select>
       <mat-spinner diameter="20" *ngIf="loadingSpinnerTipoPatrimonio"></mat-spinner> 
    </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Descrição</mat-label>
        <input 
            matInput 
            placeholder="Descrição"
            aria-label="Descrição" 
            [formControl]="descricao" 
            maxlength="140">
    </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Valor</mat-label>
        <input 
            matInput 
            placeholder="Valor" 
            [formControl]="valor"
            name="valor" 
            maxlength="20" 
            currencyMask
            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
    </mat-form-field>
</div>

<!-- Campos patrimonios Financeiros -->
<div *ngIf="is_financeiro.value">
    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
            <mat-label>Instituição Financeira</mat-label>
            <input 
            matInput 
            placeholder="Instituição Financeira"
            aria-label="Instituição Financeira" 
            [formControl]="instituicao_financeira" 
            maxlength="20">
        </mat-form-field>
    </div>
      
    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <mat-form-field style="width: 100%" appearance="outline" floatLabel="always">
            <mat-label>Vencimento</mat-label>
            <input 
                matInput 
                [matDatepicker]="dp"
                [min]="min_ano"
                placeholder="Ano - Mês" 
                [formControl]="vencimento"
            >
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker 
                #dp 
                startView="multi-year" 
                (yearSelected)="chosenYearHandler($event)"
                (monthSelected)="chosenMonthHandler($event, dp)"
                panelClass="example-month-picker">
            </mat-datepicker>
        </mat-form-field>
    </div>

    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" floatLabel="always" style="width: 100%" fxFlex="100">
            <mat-label>Open Finance</mat-label>
            <mat-select
                 [formControl]="open_finance">
                 <mat-option [value]="true">Sim</mat-option>
                 <mat-option [value]="false">Não</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerTipoPatrimonio"></mat-spinner> 
        </mat-form-field>
    </div>   
</div>

<!-- Campos patrimonios não Financeiros -->
<div *ngIf="!is_financeiro.value">
    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
            <mat-label>Saldo Devedor</mat-label>
            <input 
                matInput 
                placeholder="Saldo Devedor" 
                [formControl]="saldo_devedor"
                name="Saldo Devedor" 
                maxlength="20" 
                currencyMask
                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
        </mat-form-field>
    </div>

</div>

<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Finalidade</mat-label>
        <input 
            matInput 
            placeholder="Finalidade"
            aria-label="Finalidade" 
            [formControl]="finalidade" 
            maxlength="140">
    </mat-form-field>
</div>

 <div mat-dialog-actions style="text-align: center; margin-top: 20px;">
     <button 
         mat-button 
         tabindex="2" 
         (click)="onNoClick()">
         Cancelar
     </button>
     <button 
         mat-button 
         [disabled]="isInvalidForm()" 
         (click)="salvar()" 
         tabindex="-1">
         Salvar
     </button>
 </div>